import { remoteRequest } from './httpClient'

function normalizeScope(params = {}) {
  return {
    parentPcc: String(params.parentPcc || params.parent_pcc || '').toUpperCase(),
    pcc: String(params.pcc || '').toUpperCase(),
  }
}

function normalizeUsername(value) {
  return Number(value || 0)
}

function to01(value) {
  return value === true || value === 1 || value === '1' || value === 'true' ? 1 : 0
}

export async function listDashboardPermissions(params) {
  const scope = normalizeScope(params)
  return remoteRequest('GET', '/user/dashboard-permissions', {
    query: scope,
  })
}

export async function updateDashboardPermission(body) {
  const scope = normalizeScope(body)
  const enableScriptGenerator = to01(body.enableScriptGenerator ?? body.enable_script_generator)
  const enableRepositories = to01(body.enableRepositories ?? body.enable_repositories)
  const updatedUser = body.updatedUser || body.updated_user || 'admin_v2'
  return remoteRequest('PATCH', '/user/dashboard-permissions', {
    body: {
      username: normalizeUsername(body.username),
      parentPcc: scope.parentPcc,
      parent_pcc: scope.parentPcc,
      pcc: scope.pcc,
      enableScriptGenerator,
      enable_script_generator: enableScriptGenerator,
      enableRepositories,
      enable_repositories: enableRepositories,
      updatedUser,
      updated_user: updatedUser,
    },
  })
}

export async function deleteDashboardPermission(body) {
  const scope = normalizeScope(body)
  return remoteRequest('DELETE', '/user/dashboard-permissions', {
    query: {
      username: normalizeUsername(body.username),
      parentPcc: scope.parentPcc,
      pcc: scope.pcc,
    },
  })
}

export async function activeDashboardPermission(params) {
  const scope = normalizeScope(params)
  return remoteRequest('GET', '/user/dashboard-permissions/active', {
    query: {
      username: normalizeUsername(params.username),
      parentPcc: scope.parentPcc,
      pcc: scope.pcc,
    },
  })
}
